import type { Color } from './types';

// Кампанийные сцены-посадки: засеянные ЧЕСТНЫЕ (решаемые) состояния под рекламу.
// A — «почти-победа» (1–2 перелива до конца); C — «в процессе» (реальный решаемый
// уровень пака). Каждый цвет встречается ровно 4 раза; победа — все колбы пусты или
// одноцветны и полны. Проверять вручную через /water-sort/?scene=<id>.
//
// URL объявления: /water-sort/?scene=<id>&utm_source=<net>&utm_campaign=<c>&utm_content=<creative>

type HeadlineKey = 'hook_ws_lastpour' | 'hook_ws_almost' | 'hook_ws_midgame';

export interface Scene {
  tubes: Color[][];   // index 0 = дно колбы
  headlineKey: HeadlineKey;
}

export const SCENES: Record<string, Scene> = {
  // A: один перелив до победы — c0 разбит на t0(3)+t4(1), остальное собрано.
  'lastpour-a': {
    headlineKey: 'hook_ws_lastpour',
    tubes: [
      ['c0', 'c0', 'c0'],
      ['c1', 'c1', 'c1', 'c1'],
      ['c2', 'c2', 'c2', 'c2'],
      ['c3', 'c3', 'c3', 'c3'],
      ['c0'],
      [],
    ],
  },

  // A: два перелива до победы — t4=[c0,c3]: сперва c3→t3, затем c0→t0.
  'almost-b': {
    headlineKey: 'hook_ws_almost',
    tubes: [
      ['c0', 'c0', 'c0'],
      ['c1', 'c1', 'c1', 'c1'],
      ['c2', 'c2', 'c2', 'c2'],
      ['c3', 'c3', 'c3'],
      ['c0', 'c3'],
      [],
    ],
  },

  // C: реальный решаемый уровень пака (level 6, 5 цветов) — ощущение «продолжи партию».
  'midgame-c': {
    headlineKey: 'hook_ws_midgame',
    tubes: [
      ['c1', 'c4', 'c2', 'c4'],
      ['c0', 'c1', 'c4', 'c2'],
      ['c0', 'c3', 'c1', 'c3'],
      ['c3', 'c1', 'c4', 'c0'],
      ['c2', 'c0', 'c3', 'c2'],
      [],
      [],
    ],
  },
};
